// import React, { useState, useEffect, useMemo } from "react";
// import { useLocation } from "react-router-dom";
// import Navbar from "../../../Components/Navbar";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { useTranslation } from "react-i18next";

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import {
//   FaCalendarAlt,
//   FaStar,
//   FaStarHalfAlt,
//   FaRegStar,
// } from "react-icons/fa";

// import GasChulaOrderForm from "./GasChulaOrderForm";
// import PromptLoginCard from "../PromptLoginCard";
// import FeedbackPage from "../../Feedback/FeedbackPage";
// import Footer from "../../../Components/Footer/Footer";

// import heroImage from "../images/gas-chula.png";

// import "./gasChulaStyle.css";

// const GasChula = () => {
//   const { t } = useTranslation();
//   const location = useLocation();
//   const rebookState = location.state?.fromRebook || false;
//   const prevOrder = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );

//   // Form fields
//   const [cylinderType, setCylinderType] = useState("");
//   const [newChulaSetup, setNewChulaSetup] = useState(0);
//   const [chulaSetup, setChulaSetup] = useState(0);
//   const [burnerSetup, setBurnerSetup] = useState(0);
//   const [burnerCleaning, setBurnerCleaning] = useState(0);
//   const [nozzleReplacement, setNozzleReplacement] = useState(0);
//   const [checkIssues, setCheckIssues] = useState(false);
//   const [remarks, setRemarks] = useState("");

//   // Rebook same servitor
//   const [useSameServitor, setUseSameServitor] = useState(false);
//   const [prevServitorName, setPrevServitorName] = useState("");

//   // Rating data
//   const [ratingData, setRatingData] = useState({
//     reviewCount: 0,
//     avgRating: 0,
//   });

//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({});

//   // Date & time
//   const getInitialDate = () => {
//     const now = new Date();
//     const currentHour = now.getHours();
//     if (currentHour < 7 || currentHour >= 21) {
//       const tomorrow = new Date();
//       tomorrow.setDate(now.getDate() + 1);
//       return tomorrow;
//     }
//     return now;
//   };
//   const [selectedDate, setSelectedDate] = useState(getInitialDate());

//   // Populate fields for rebook
//   useEffect(() => {
//     if (rebookState) {
//       setCylinderType(prevOrder.chulaCylinderType || "");
//       setNewChulaSetup(prevOrder.NewchulaSetup || 0);
//       setChulaSetup(prevOrder.chulaSetup || 0);
//       setBurnerSetup(prevOrder.burnerSetup || 0);
//       setBurnerCleaning(prevOrder.burnerCleaning || 0);
//       setNozzleReplacement(prevOrder.nozzleReplacement || 0);
//       setCheckIssues(prevOrder.checkIssues || false);
//       setRemarks(prevOrder.remarks || "");
//     }
//   }, [rebookState, prevOrder]);

//   // Fetch user profile
//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;

//           const response = await axios.get(`${URL}/user/${userId}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching user data:", error);
//       }
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);

//   // Fetch servitor name for rebook
//   useEffect(() => {
//     if (rebookState && prevOrder.servitor_id) {
//       axios
//         .get(`${URL}/servitors/${prevOrder.servitor_id}`)
//         .then((res) => {
//           const s = res.data;
//           setPrevServitorName(`${s.FirstName} ${s.LastName}`);
//         })
//         .catch((err) => console.error("Error fetching servitor:", err));
//     }
//   }, [rebookState, prevOrder.servitor_id]);

//   // Fetch gas chula ratings
//   useEffect(() => {
//     axios
//       .get(`${URL}/api/ratings`)
//       .then(({ data }) => {
//         const { gasChula } = data; // Assuming API returns gasChula ratings
//         setRatingData({
//           reviewCount: gasChula.reviewCount || 0,
//           avgRating: gasChula.avgRating || 0,
//         });
//       })
//       .catch((err) => console.error("Failed to load ratings:", err));
//   }, []);

//   // Render star ratings
//   const renderStars = (rating) => {
//     const stars = [];
//     for (let i = 1; i <= 5; i++) {
//       if (rating >= i) {
//         stars.push(<FaStar key={i} />);
//       } else if (rating >= i - 0.5) {
//         stars.push(<FaStarHalfAlt key={i} />);
//       } else {
//         stars.push(<FaRegStar key={i} />);
//       }
//     }
//     return stars;
//   };

//   // Generate time slots
//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21;
//     const slots = [];
//     const now = new Date();
//     const todayStr = now.toISOString().split("T")[0];
//     const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";

//     let startHour = startTime;
//     let startMinute = 0;

//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) {
//         return [];
//       }
//       if (currentHour >= startTime) {
//         if (currentMinute > 0 && currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute > 30) {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         } else {
//           startHour = currentHour;
//           startMinute = 0;
//         }
//       }
//     }

//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? "PM" : "AM";
//         const formattedTime = `${displayHour}:${String(minute).padStart(
//           2,
//           "0"
//         )} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };

//   // Calculate price
//   const calculatePrice = () => {
//     let price = 200; // Base price
//     price += newChulaSetup * 300;
//     price += chulaSetup * 200;
//     price += burnerSetup * 150;
//     price += burnerCleaning * 100;
//     price += nozzleReplacement * 120;
//     if (checkIssues) price += 80;
//     return price;
//   };

//   // Handle form submission
//   const handleGetService = (e) => {
//     e.preventDefault();
//     const dateStr = selectedDate.toISOString().split("T")[0];
//     const time = e.target.time.value;

//     const formDetails = {
//       chulaCylinderType: cylinderType,
//       NewchulaSetup: newChulaSetup,
//       chulaSetup,
//       burnerSetup,
//       burnerCleaning,
//       nozzleReplacement,
//       checkIssues,
//       remarks,
//       price: calculatePrice(),
//       date: dateStr,
//       time,
//       useSameServitor,
//       previousServitorId: useSameServitor ? prevOrder.servitor_id : undefined,
//     };
//     setFormData(formDetails);

//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };

//   // Handle order submission
//   const handleOrderSubmit = () => {
//     setShowOrderForm(false);
//     // Reset form
//     setCylinderType("");
//     setNewChulaSetup(0);
//     setChulaSetup(0);
//     setBurnerSetup(0);
//     setBurnerCleaning(0);
//     setNozzleReplacement(0);
//     setCheckIssues(false);
//     setRemarks("");
//     setUseSameServitor(false);
//     setFormData({});
//   };

//   // PlusMinusInput component
//   const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
//     const handleIncrement = () => {
//       if (value < max) setValue(value + 1);
//     };
//     const handleDecrement = () => {
//       if (value > min) setValue(value - 1);
//     };
//     return (
//       <div className="GasChulaService-plusMinusInput">
//         <button
//           type="button"
//           className="GasChulaService-minusBtn"
//           onClick={handleDecrement}
//           disabled={value <= min}
//         >
//           −
//         </button>
//         <span className="GasChulaService-valueDisplay">
//           {value} {t(value === 1 ? "gasChula.form.unit" : "gasChula.form.units")}
//         </span>
//         <button
//           type="button"
//           className="GasChulaService-plusBtn"
//           onClick={handleIncrement}
//           disabled={value >= max}
//         >
//           +
//         </button>
//       </div>
//     );
//   };

//   // Helper to safely get array translations
//   const getTranslationArray = (key) => {
//     const result = t(key, { returnObjects: true });
//     return Array.isArray(result) ? result : [];
//   };

//   return (
//     <>
//       <div className="GasChulaService-container">
//         <Navbar />

//         {/* Service Card */}
//         <div className="GasChulaService-card">
//           {/* Hero Section */}
//           <div className="GasChulaService-hero">
//             <img src={heroImage} alt={t("gasChula.hero_alt")} />
//           </div>

//           <div className="GasChulaService-header">
//             <h1>
//               {rebookState
//                 ? t("gasChula.header.rebook_title")
//                 : t("gasChula.header.title")}
//             </h1>
//             <div className="GasChulaService-rating">
//               {renderStars(ratingData.avgRating)}
//             </div>
//             <div className="GasChulaService-reviews">
//               {ratingData.reviewCount.toLocaleString()}{" "}
//               {t("gasChula.reviewsLabel")}
//             </div>
//           </div>

//           {/* Categories / Info Blocks */}
//           <div className="GasChulaService-categories">
//             <div className="GasChulaService-category">
//               <h5>
//                 <span className="GasChulaService-categoryIcon">🔥</span>
//                 {t("gasChula.categories.setup_services.title")}
//               </h5>
//               <p className="GasChulaService-serviceDescription">
//                 {t("gasChula.categories.setup_services.description")}
//               </p>
//             </div>
//             <div className="GasChulaService-category">
//               <h5>
//                 <span className="GasChulaService-categoryIcon">🛠️</span>
//                 {t("gasChula.categories.maintenance.title")}
//               </h5>
//               <p className="GasChulaService-serviceDescription">
//                 {t("gasChula.categories.maintenance.description")}
//               </p>
//             </div>
//             <div className="GasChulaService-category">
//               <h5>
//                 <span className="GasChulaService-categoryIcon">🔍</span>
//                 {t("gasChula.categories.safety_check.title")}
//               </h5>
//               <p className="GasChulaService-serviceDescription">
//                 {t("gasChula.categories.safety_check.description")}
//               </p>
//             </div>
//           </div>

//           {/* The Service Form */}
//           <form onSubmit={handleGetService} className="GasChulaService-form">
//             {/* Cylinder Type */}
//             <h3 className="GasChulaService-sectionTitle">
//               <i className="fas fa-gas-pump"></i>
//               {t("gasChula.form.cylinder_type_title")}
//             </h3>
//             <div className="GasChulaService-serviceOptions">
//               <div className="GasChulaService-optionGroup GasChulaService-fullWidth">
//                 <label htmlFor="cylinderType">
//                   {t("gasChula.form.labels.cylinderType")}
//                 </label>
//                 <select
//                   id="cylinderType"
//                   value={cylinderType}
//                   onChange={(e) => setCylinderType(e.target.value)}
//                   required
//                 >
//                   <option value="">
//                     {t("gasChula.form.placeholders.select")}
//                   </option>
//                   <option value="LPG">LPG</option>
//                   <option value="Gas">Gas</option>
//                 </select>
//               </div>
//             </div>

//             {/* Setup Services */}
//             <h3 className="GasChulaService-sectionTitle">
//               <i className="fas fa-tools"></i>
//               {t("gasChula.form.setup_services_title")}
//             </h3>
//             <div className="GasChulaService-serviceOptions">
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="newChulaSetup">
//                   {t("gasChula.form.labels.newSetup")}
//                 </label>
//                 <PlusMinusInput
//                   id="newChulaSetup"
//                   value={newChulaSetup}
//                   setValue={setNewChulaSetup}
//                 />
//               </div>
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="chulaSetup">
//                   {t("gasChula.form.labels.chulaSetup")}
//                 </label>
//                 <PlusMinusInput
//                   id="chulaSetup"
//                   value={chulaSetup}
//                   setValue={setChulaSetup}
//                 />
//               </div>
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="burnerSetup">
//                   {t("gasChula.form.labels.burnerSetup")}
//                 </label>
//                 <PlusMinusInput
//                   id="burnerSetup"
//                   value={burnerSetup}
//                   setValue={setBurnerSetup}
//                 />
//               </div>
//             </div>

//             {/* Maintenance Services */}
//             <h3 className="GasChulaService-sectionTitle">
//               <i className="fas fa-wrench"></i>
//               {t("gasChula.form.maintenance_services_title")}
//             </h3>
//             <div className="GasChulaService-serviceOptions">
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="burnerCleaning">
//                   {t("gasChula.form.labels.burnerCleaning")}
//                 </label>
//                 <PlusMinusInput
//                   id="burnerCleaning"
//                   value={burnerCleaning}
//                   setValue={setBurnerCleaning}
//                 />
//               </div>
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="nozzleReplacement">
//                   {t("gasChula.form.labels.nozzleReplacement")}
//                 </label>
//                 <PlusMinusInput
//                   id="nozzleReplacement"
//                   value={nozzleReplacement}
//                   setValue={setNozzleReplacement}
//                 />
//               </div>
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="checkIssues">
//                   {t("gasChula.form.labels.checkIssues")}
//                 </label>
//                 <select
//                   id="checkIssues"
//                   value={checkIssues ? "yes" : "no"}
//                   onChange={(e) => setCheckIssues(e.target.value === "yes")}
//                 >
//                   <option value="no">
//                     {t("gasChula.form.labels.checkIssues_options.no")}
//                   </option>
//                   <option value="yes">
//                     {t("gasChula.form.labels.checkIssues_options.yes")}
//                   </option>
//                 </select>
//               </div>
//             </div>

//             {/* Rebook Same Servitor */}
//             {rebookState && prevServitorName && (
//               <div className="GasChulaService-rebook-same-servitor">
//                 <label>
//                   <input
//                     type="checkbox"
//                     checked={useSameServitor}
//                     onChange={() => setUseSameServitor(!useSameServitor)}
//                   />
//                   <span className="rebook-text">
//                     {t("gasChula.form.rebook_same_servitor_prefix")}
//                     <span className="strong-name">{prevServitorName}</span>
//                     {t("gasChula.form.rebook_same_servitor_suffix")}
//                   </span>
//                 </label>
//               </div>
//             )}

//             {/* Price Display */}
//             <div className="GasChulaService-priceDisplay">
//               <span>
//                 {t("gasChula.form.price_display", { price: calculatePrice() })}
//               </span>
//               {/* <small>{t("gasChula.form.price_note")}</small> */}
//             </div>

//             {/* Booking Details */}
//             <div className="GasChulaService-bookingDetails">
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="date">{t("gasChula.form.labels.date")}</label>
//                 <div className="GasChulaService-dateInputWrapper">
//                   <DatePicker
//                     selected={selectedDate}
//                     onChange={(date) => setSelectedDate(date)}
//                     dateFormat="dd-MMM-yyyy"
//                     minDate={new Date()}
//                     placeholderText={t("gasChula.form.labels.date")}
//                     className="GasChulaService-dateInput"
//                   />
//                   <FaCalendarAlt
//                     className="GasChulaService-dateIcon"
//                     onClick={() =>
//                       document
//                         .querySelector(".GasChulaService-dateInput")
//                         .focus()
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="time">{t("gasChula.form.labels.time")}</label>
//                 <select id="time" name="time" required>
//                   {generateTimeSlots(selectedDate).map((slot, idx) => (
//                     <option key={idx} value={slot}>
//                       {slot}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             {/* Remarks */}
//             <div className="GasChulaService-serviceOptions">
//               <div className="GasChulaService-optionGroup GasChulaService-fullWidth">
//                 <label htmlFor="remarks">
//                   <i className="fas fa-comment-alt"></i>
//                   {t("gasChula.form.labels.remarks")}
//                 </label>
//                 <textarea
//                   id="remarks"
//                   value={remarks}
//                   onChange={(e) => setRemarks(e.target.value)}
//                   placeholder={t("gasChula.form.placeholders.remarks")}
//                   className="GasChulaService-textarea"
//                   rows="2"
//                 />
//               </div>
//             </div>

//             <button type="submit" className="GasChulaService-actionBtn">
//               {rebookState
//                 ? t("gasChula.form.rebook_button")
//                 : t("gasChula.form.book_button")}
//             </button>
//           </form>

//           {/* Info Box */}
//           <div className="GasChulaService-infoBox">
//             <h4>{t("gasChula.info_box.title")}</h4>
//             <p>{t("gasChula.info_box.description")}</p>
//           </div>

//           {/* Additional Info Section */}
//           <div className="GasChulaService-additionalInfo">
//             <div className="GasChulaService-sectionCard">
//               <h2 className="GasChulaService-sectionTitle">
//                 {t("gasChula.additional_info.how_to_place_order.title")}
//               </h2>
//               <ol className="GasChulaService-stepList">
//                 {getTranslationArray(
//                   "gasChula.additional_info.how_to_place_order.steps"
//                 ).map((step, idx) => (
//                   <li key={idx}>{step}</li>
//                 ))}
//               </ol>
//             </div>

//             <div className="GasChulaService-row2col">
//               <div className="GasChulaService-sectionCard GasChulaService-gradientBg2">
//                 <h2 className="GasChulaService-sectionTitle">
//                   {t("gasChula.additional_info.why_choose_HelpNao.title")}
//                 </h2>
//                 <p className="GasChulaService-sectionText">
//                   {t("gasChula.additional_info.why_choose_HelpNao.description")}
//                 </p>
//                 <div className="GasChulaService-featureGrid">
//                   {getTranslationArray(
//                     "gasChula.additional_info.why_choose_HelpNao.features"
//                   ).map((feature, idx) => (
//                     <div key={idx} className="GasChulaService-featureItem">
//                       <i
//                         className={`fas fa-${
//                           idx === 0
//                             ? "balance-scale"
//                             : idx === 1
//                             ? "user-shield"
//                             : idx === 2
//                             ? "mobile-alt"
//                             : "headset"
//                         } GasChulaService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               <div className="GasChulaService-sectionCard GasChulaService-gradientBg">
//                 <h2 className="GasChulaService-sectionTitle">
//                   {t("gasChula.additional_info.key_features.title")}
//                 </h2>
//                 <div className="GasChulaService-featureGrid">
//                   {getTranslationArray(
//                     "gasChula.additional_info.key_features.features"
//                   ).map((feature, idx) => (
//                     <div key={idx} className="GasChulaService-featureItem">
//                       <i
//                         className={`fas fa-${
//                           idx === 0
//                             ? "clock"
//                             : idx === 1
//                             ? "shield-alt"
//                             : idx === 2
//                             ? "check-circle"
//                             : idx === 3
//                             ? "shield-alt"
//                             : "credit-card"
//                         } GasChulaService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             <div className="GasChulaService-sectionCard">
//               <h2 className="GasChulaService-sectionTitle">
//                 {t("gasChula.additional_info.service_details.title")}
//               </h2>
//               <div className="GasChulaService-serviceGrid">
//                 {getTranslationArray(
//                   "gasChula.additional_info.service_details.items"
//                 ).map((item, idx) => (
//                   <div key={idx} className="GasChulaService-serviceItem">
//                     <i
//                       className={`fas fa-${
//                         idx === 0 ? "fire" : "tools"
//                       } GasChulaService-serviceIcon`}
//                       aria-hidden="true"
//                     ></i>
//                     <div>
//                       <h3>{item.title}</h3>
//                       <p>{item.description}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div className="GasChulaService-sectionCard GasChulaService-gradientBg3">
//               <h2 className="GasChulaService-sectionTitle">
//                 {t("gasChula.additional_info.order_tracking.title")}
//               </h2>
//               <div className="GasChulaService-orderTrackIcon">
//                 <i className="fas fa-file-alt" aria-hidden="true"></i>
//               </div>
//               <p className="GasChulaService-sectionText GasChulaService-centerText">
//                 {t("gasChula.additional_info.order_tracking.description")}
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Modals */}
//         <GasChulaOrderForm
//           onClose={() => setShowOrderForm(false)}
//           onSubmit={handleOrderSubmit}
//           formData={formData}
//           user={user}
//           previousServitorName={prevServitorName}
//         />
//         {showLoginPrompt && (
//           <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
//         )}
//       </div>

//       {/* Feedback Section */}
//       <div className="GasChulaService-feedback-section">
//         <FeedbackPage serviceType="Gas Chula" />
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default GasChula;


















// ***** All okay checked code below (25-Oct-2025) *****
// import React, { useState, useEffect, useMemo } from "react";
// import { useLocation } from "react-router-dom";
// import Navbar from "../../../Components/Navbar";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { useTranslation } from "react-i18next";

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import {
//   FaCalendarAlt,
//   FaStar,
//   FaStarHalfAlt,
//   FaRegStar,
// } from "react-icons/fa";

// import PromptLoginCard from "../PromptLoginCard";
// import FeedbackPage from "../../Feedback/FeedbackPage";
// import Footer from "../../../Components/Footer/Footer";
// import GasChulaOrderForm from "./GasChulaOrderForm";

// import heroImage from "../images/gas-chula.png";
// import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";

// import "./gasChulaStyle.css";
// import Loader from "../../../Components/LoaderSpin/Loader";

// const GasChula = () => {
//   const { t } = useTranslation();
//   const location = useLocation();
//   const rebookState = location.state?.fromRebook || false;
//   const prevOrder = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );

//   // Form fields
//   const [cylinderType, setCylinderType] = useState("");
//   const [newChulaSetup, setNewChulaSetup] = useState(0);
//   const [chulaSetup, setChulaSetup] = useState(0);
//   const [burnerSetup, setBurnerSetup] = useState(0);
//   const [burnerCleaning, setBurnerCleaning] = useState(0);
//   const [nozzleReplacement, setNozzleReplacement] = useState(0);
//   const [checkIssues, setCheckIssues] = useState(false);
//   const [remarks, setRemarks] = useState("");

//   // Rebook same servitor
//   const [useSameServitor, setUseSameServitor] = useState(false);
//   const [prevServitorName, setPrevServitorName] = useState("");

//   // Rating data
//   const [ratingData, setRatingData] = useState({
//     reviewCount: 0,
//     avgRating: 0,
//   });

//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({});
//   const [loading, setLoading] = useState(true);

//   // Date & time
//   const getInitialDate = () => {
//     const now = new Date();
//     const currentHour = now.getHours();
//     if (currentHour < 7 || currentHour >= 21) {
//       const tomorrow = new Date();
//       tomorrow.setDate(now.getDate() + 1);
//       return tomorrow;
//     }
//     return now;
//   };
//   const [selectedDate, setSelectedDate] = useState(getInitialDate());

//   // Populate fields for rebook
//   useEffect(() => {
//     if (rebookState) {
//       setCylinderType(prevOrder.chulaCylinderType || "");
//       setNewChulaSetup(prevOrder.NewchulaSetup || 0);
//       setChulaSetup(prevOrder.chulaSetup || 0);
//       setBurnerSetup(prevOrder.burnerSetup || 0);
//       setBurnerCleaning(prevOrder.burnerCleaning || 0);
//       setNozzleReplacement(prevOrder.nozzleReplacement || 0);
//       setCheckIssues(prevOrder.checkIssues || false);
//       setRemarks(prevOrder.remarks || "");
//     }
//   }, [rebookState, prevOrder]);

//   // Fetch user profile
//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         setLoading(true);
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;

//           const response = await axios.get(`${URL}/user/${userId}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching user data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);

//   // Fetch servitor name for rebook
//   useEffect(() => {
//     if (rebookState && prevOrder.servitor_id) {
//       axios
//         .get(`${URL}/servitors/${prevOrder.servitor_id}`)
//         .then((res) => {
//           const s = res.data;
//           setPrevServitorName(`${s.FirstName} ${s.LastName}`);
//         })
//         .catch((err) => console.error("Error fetching servitor:", err));
//     }
//   }, [rebookState, prevOrder.servitor_id]);

//   // Fetch gas chula ratings
//   // useEffect(() => {
//   //   axios
//   //     .get(`${URL}/api/ratings`)
//   //     .then(({ data }) => {
//   //       // const { gasChula } = data;
//   //       // const gasChula = data?.gasChula || {};
//   //       const gasChula = data["gas chula"] || {};
//   //       setRatingData({
//   //         reviewCount: gasChula.reviewCount || 0,
//   //         avgRating: gasChula.avgRating || 0,
//   //       });
//   //     })
//   //     .catch((err) => {console.error("Failed to load ratings:", err)});
//   // }, []);

//   useEffect(() => {
//     const loadRatings = async () => {
//       try {
//         setLoading(true);
//         const { data } = await axios.get(`${URL}/api/ratings`);
//         // handle different backend key styles
//         const gasChula = data["gas chula"] || {};
//         setRatingData({
//           reviewCount: gasChula.reviewCount || 0,
//           avgRating: gasChula.avgRating || 0,
//         });
//       } catch (err) {
//         console.error("Failed to load ratings:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     loadRatings();
//   }, []);

//   // Render star ratings
//   const renderStars = (rating) => {
//     const stars = [];
//     for (let i = 1; i <= 5; i++) {
//       if (rating >= i) {
//         stars.push(<FaStar key={i} />);
//       } else if (rating >= i - 0.5) {
//         stars.push(<FaStarHalfAlt key={i} />);
//       } else {
//         stars.push(<FaRegStar key={i} />);
//       }
//     }
//     return stars;
//   };

//   // Generate time slots
//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21;
//     const slots = [];
//     const now = new Date();
//     const todayStr = now.toISOString().split("T")[0];
//     const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";

//     let startHour = startTime;
//     let startMinute = 0;

//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) {
//         return [];
//       }
//       if (currentHour >= startTime) {
//         if (currentMinute > 0 && currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute > 30) {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         } else {
//           startHour = currentHour;
//           startMinute = 0;
//         }
//       }
//     }

//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? "PM" : "AM";
//         const formattedTime = `${displayHour}:${String(minute).padStart(
//           2,
//           "0"
//         )} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };

//   // Calculate price
//   const calculatePrice = () => {
//     let price = 100;
//     price += newChulaSetup * 500;
//     price += chulaSetup * 300;
//     price += burnerSetup * 200;
//     price += burnerCleaning * 150;
//     price += nozzleReplacement * 120;
//     if (checkIssues) price += 100;
//     return price;
//   };

//   // Handle form submission
//   const handleGetService = (e) => {
//     e.preventDefault();
//     const dateStr = selectedDate.toISOString().split("T")[0];
//     const time = e.target.time.value;

//     const formDetails = {
//       chulaCylinderType: cylinderType,
//       NewchulaSetup: newChulaSetup,
//       chulaSetup,
//       burnerSetup,
//       burnerCleaning,
//       nozzleReplacement,
//       checkIssues,
//       remarks,
//       price: calculatePrice(),
//       date: dateStr,
//       time,
//       useSameServitor,
//       previousServitorId: useSameServitor ? prevOrder.servitor_id : undefined,
//       serviceId: 2, // Assuming Gas Chula service ID is 2
//     };
//     setFormData(formDetails);

//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };

//   // Handle order submission
//   const handleOrderSubmit = () => {
//     setShowOrderForm(false);
//     // Reset form
//     setCylinderType("");
//     setNewChulaSetup(0);
//     setChulaSetup(0);
//     setBurnerSetup(0);
//     setBurnerCleaning(0);
//     setNozzleReplacement(0);
//     setCheckIssues(false);
//     setRemarks("");
//     setUseSameServitor(false);
//     setFormData({});
//   };

//   // PlusMinusInput component
//   const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
//     const handleIncrement = () => {
//       if (value < max) setValue(value + 1);
//     };
//     const handleDecrement = () => {
//       if (value > min) setValue(value - 1);
//     };
//     return (
//       <div className="GasChulaService-plusMinusInput">
//         <button
//           type="button"
//           className="GasChulaService-minusBtn"
//           onClick={handleDecrement}
//           disabled={value <= min}
//         >
//           −
//         </button>
//         <span className="GasChulaService-valueDisplay">
//           {value} {t(value === 1 ? "gasChula.form.unit" : "gasChula.form.units")}
//         </span>
//         <button
//           type="button"
//           className="GasChulaService-plusBtn"
//           onClick={handleIncrement}
//           disabled={value >= max}
//         >
//           +
//         </button>
//       </div>
//     );
//   };

//   // Helper to safely get array translations
//   const getTranslationArray = (key) => {
//     const result = t(key, { returnObjects: true });
//     return Array.isArray(result) ? result : [];
//   };

//   return (
//     <>
//       <div className="GasChulaService-container">
//         <Navbar />
//         <Loader show={loading} />

//         {/* Service Card */}
//         <div className="GasChulaService-card">
//           {/* Hero Section */}
//           <div className="GasChulaService-hero">
//             <img src={heroImage} alt={t("gasChula.hero_alt")} />
//           </div>

//           <div className="GasChulaService-header">
//             <h1>
//               {rebookState
//                 ? t("gasChula.header.rebook_title")
//                 : t("gasChula.header.title")}
//             </h1>
//             <div className="GasChulaService-rating">
//               {renderStars(ratingData.avgRating)}
//             </div>
//             <div className="GasChulaService-reviews">
//               {ratingData.reviewCount.toLocaleString()}{" "}
//               {t("gasChula.reviewsLabel")}
//             </div>
//           </div>

//           {/* Categories / Info Blocks */}
//           <div className="GasChulaService-categories">
//             <div className="GasChulaService-category">
//               <h5>
//                 <span className="GasChulaService-categoryIcon">🔥</span>
//                 {t("gasChula.categories.setup_services.title")}
//               </h5>
//               <p className="GasChulaService-serviceDescription">
//                 {t("gasChula.categories.setup_services.description")}
//               </p>
//             </div>
//             <div className="GasChulaService-category">
//               <h5>
//                 <span className="GasChulaService-categoryIcon">🛠️</span>
//                 {t("gasChula.categories.maintenance.title")}
//               </h5>
//               <p className="GasChulaService-serviceDescription">
//                 {t("gasChula.categories.maintenance.description")}
//               </p>
//             </div>
//             <div className="GasChulaService-category">
//               <h5>
//                 <span className="GasChulaService-categoryIcon">🔍</span>
//                 {t("gasChula.categories.safety_check.title")}
//               </h5>
//               <p className="GasChulaService-serviceDescription">
//                 {t("gasChula.categories.safety_check.description")}
//               </p>
//             </div>
//           </div>

//           {/* The Service Form */}
//           <form onSubmit={handleGetService} className="GasChulaService-form">
//             {/* Cylinder Type */}
//             <h3 className="GasChulaService-sectionTitle">
//               <i className="fas fa-gas-pump"></i>
//               {t("gasChula.form.cylinder_type_title")}
//             </h3>
//             <div className="GasChulaService-serviceOptions">
//               <div className="GasChulaService-optionGroup GasChulaService-fullWidth">
//                 <label htmlFor="cylinderType">
//                   {t("gasChula.form.labels.cylinderType")}
//                 </label>
//                 <select
//                   id="cylinderType"
//                   value={cylinderType}
//                   onChange={(e) => setCylinderType(e.target.value)}
//                   required
//                 >
//                   <option value="">
//                     {t("gasChula.form.placeholders.select")}
//                   </option>
//                   <option value="LPG">LPG</option>
//                   <option value="Line Gas">Line Gas</option>
//                 </select>
//               </div>
//             </div>

//             {/* Setup Services */}
//             <h3 className="GasChulaService-sectionTitle">
//               <i className="fas fa-tools"></i>
//               {t("gasChula.form.setup_services_title")}
//             </h3>
//             <div className="GasChulaService-serviceOptions">
//               <div className="GasChulaService-optionGroup">
//                <label htmlFor="newChulaSetup" className="tooltip-label">
//                      {t("gasChula.form.labels.newSetup")}
//                      <ServiceTooltip
//                        title={t("gasChula.tooltips.newSetup.title")}
//                        description={t("gasChula.tooltips.newSetup.description")}
//                      />
//                    </label>
//                 <PlusMinusInput
//                   id="newChulaSetup"
//                   value={newChulaSetup}
//                   setValue={setNewChulaSetup}
//                 />
//               </div>
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="chulaSetup" className="tooltip-label">
//                       {t("gasChula.form.labels.chulaSetup")}
//                       <ServiceTooltip
//                         title={t("gasChula.tooltips.chulaSetup.title")}
//                         description={t("gasChula.tooltips.chulaSetup.description")}
//                       />
//                     </label>
//                 <PlusMinusInput
//                   id="chulaSetup"
//                   value={chulaSetup}
//                   setValue={setChulaSetup}
//                 />
//               </div>
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="burnerSetup" className="tooltip-label">
//                       {t("gasChula.form.labels.burnerSetup")}
//                       <ServiceTooltip
//                         title={t("gasChula.tooltips.burnerSetup.title")}
//                         description={t("gasChula.tooltips.burnerSetup.description")}
//                       />
//                     </label>
//                 <PlusMinusInput
//                   id="burnerSetup"
//                   value={burnerSetup}
//                   setValue={setBurnerSetup}
//                 />
//               </div>
//             </div>

//             {/* Maintenance Services */}
//             <h3 className="GasChulaService-sectionTitle">
//               <i className="fas fa-wrench"></i>
//               {t("gasChula.form.maintenance_services_title")}
//             </h3>
//             <div className="GasChulaService-serviceOptions">
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="burnerCleaning" className="tooltip-label">
//                       {t("gasChula.form.labels.burnerCleaning")}
//                       <ServiceTooltip
//                         title={t("gasChula.tooltips.burnerCleaning.title")}
//                         description={t("gasChula.tooltips.burnerCleaning.description")}
//                       />
//                     </label>
//                 <PlusMinusInput
//                   id="burnerCleaning"
//                   value={burnerCleaning}
//                   setValue={setBurnerCleaning}
//                 />
//               </div>
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="nozzleReplacement" className="tooltip-label">
//                       {t("gasChula.form.labels.nozzleReplacement")}
//                       <ServiceTooltip
//                         title={t("gasChula.tooltips.nozzleReplacement.title")}
//                         description={t("gasChula.tooltips.nozzleReplacement.description")}
//                       />
//                     </label>
//                 <PlusMinusInput
//                   id="nozzleReplacement"
//                   value={nozzleReplacement}
//                   setValue={setNozzleReplacement}
//                 />
//               </div>
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="checkIssues" className="tooltip-label">
//                       {t("gasChula.form.labels.checkIssues")}
//                       <ServiceTooltip
//                         title={t("gasChula.tooltips.checkIssues.title")}
//                         description={t("gasChula.tooltips.checkIssues.description")}
//                       />
//                     </label>
//                 <select
//                   id="checkIssues"
//                   value={checkIssues ? "yes" : "no"}
//                   onChange={(e) => setCheckIssues(e.target.value === "yes")}
//                 >
//                   <option value="no">
//                     {t("gasChula.form.labels.checkIssues_options.no")}
//                   </option>
//                   <option value="yes">
//                     {t("gasChula.form.labels.checkIssues_options.yes")}
//                   </option>
//                 </select>
//               </div>
//             </div>

//             {/* Rebook Same Servitor */}
//             {rebookState && prevServitorName && (
//               <div className="GasChulaService-rebook-same-servitor">
//                 <label>
//                   <input
//                     type="checkbox"
//                     checked={useSameServitor}
//                     onChange={() => setUseSameServitor(!useSameServitor)}
//                   />
//                   <span className="rebook-text">
//                     {t("gasChula.form.rebook_same_servitor_prefix")}
//                     <span className="strong-name">{prevServitorName}</span>
//                     {t("gasChula.form.rebook_same_servitor_suffix")}
//                   </span>
//                 </label>
//               </div>
//             )}

//             {/* Price Display */}
//             <div className="GasChulaService-priceDisplay">
//               <span>
//                 {t("gasChula.form.price_display", { price: calculatePrice() })}
//               </span>
//               {/* <small>{t("gasChula.form.price_note")}</small> */}
//             </div>

//            {/* Pricing note banner */}
//             <div className="GasChulaService-priceNote" role="note" aria-live="polite">
//               <div className="GasChulaService-priceNote-icon" aria-hidden="true">
//                 {/* small star icon (inline SVG) */}
//                 <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
//                   <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
//                 </svg>
//               </div>
//               <div className="GasChulaService-priceNote-content">
//                 <div className="GasChulaService-priceNote-title">
//                   {t("gasChula.price_note.title")}
//                 </div>
//                 <p className="GasChulaService-priceNote-text">
//                   <strong>{t("gasChula.price_note.service_charges_only_label")}</strong>{" "}
//                   {t("gasChula.price_note.body")}
//                 </p>
//               </div>
//             </div>



//             {/* Booking Details */}
//             <div className="GasChulaService-bookingDetails">
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="date">{t("gasChula.form.labels.date")}</label>
//                 <div className="GasChulaService-dateInputWrapper">
//                   <DatePicker
//                     selected={selectedDate}
//                     onChange={(date) => setSelectedDate(date)}
//                     dateFormat="dd-MMM-yyyy"
//                     minDate={new Date()}
//                     placeholderText={t("gasChula.form.labels.date")}
//                     className="GasChulaService-dateInput"
//                   />
//                   <FaCalendarAlt
//                     className="GasChulaService-dateIcon"
//                     onClick={() =>
//                       document
//                         .querySelector(".GasChulaService-dateInput")
//                         .focus()
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="GasChulaService-optionGroup">
//                 <label htmlFor="time">{t("gasChula.form.labels.time")}</label>
//                 <select id="time" name="time" required>
//                   {generateTimeSlots(selectedDate).map((slot, idx) => (
//                     <option key={idx} value={slot}>
//                       {slot}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             {/* Remarks */}
//             <div className="GasChulaService-serviceOptions">
//               <div className="GasChulaService-optionGroup GasChulaService-fullWidth">
//                 <label htmlFor="remarks">
//                   <i className="fas fa-comment-alt"></i>
//                   {t("gasChula.form.labels.remarks")}
//                 </label>
//                 <textarea
//                   id="remarks"
//                   value={remarks}
//                   onChange={(e) => setRemarks(e.target.value)}
//                   placeholder={t("gasChula.form.placeholders.remarks")}
//                   className="GasChulaService-textarea"
//                   rows="2"
//                 />
//               </div>
//             </div>

//             <button type="submit" className="GasChulaService-actionBtn">
//               {rebookState
//                 ? t("gasChula.form.rebook_button")
//                 : t("gasChula.form.book_button")}
//             </button>
//           </form>

//           {/* Info Box */}
//           <div className="GasChulaService-infoBox">
//             <h4>{t("gasChula.info_box.title")}</h4>
//             <p>{t("gasChula.info_box.description")}</p>
//           </div>

//           {/* Additional Info Section */}
//           <div className="GasChulaService-additionalInfo">
//             <div className="GasChulaService-sectionCard">
//               <h2 className="GasChulaService-sectionTitle">
//                 {t("gasChula.additional_info.how_to_place_order.title")}
//               </h2>
//               <ol className="GasChulaService-stepList">
//                 {getTranslationArray(
//                   "gasChula.additional_info.how_to_place_order.steps"
//                 ).map((step, idx) => (
//                   <li key={idx}>{step}</li>
//                 ))}
//               </ol>
//             </div>

//             <div className="GasChulaService-row2col">
//               <div className="GasChulaService-sectionCard GasChulaService-gradientBg2">
//                 <h2 className="GasChulaService-sectionTitle">
//                   {t("gasChula.additional_info.why_choose_HelpNao.title")}
//                 </h2>
//                 <p className="GasChulaService-sectionText">
//                   {t("gasChula.additional_info.why_choose_HelpNao.description")}
//                 </p>
//                 <div className="GasChulaService-featureGrid">
//                   {getTranslationArray(
//                     "gasChula.additional_info.why_choose_HelpNao.features"
//                   ).map((feature, idx) => (
//                     <div key={idx} className="GasChulaService-featureItem">
//                       <i
//                         className={`fas fa-${
//                           idx === 0
//                             ? "balance-scale"
//                             : idx === 1
//                             ? "user-shield"
//                             : idx === 2
//                             ? "mobile-alt"
//                             : "headset"
//                         } GasChulaService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               <div className="GasChulaService-sectionCard GasChulaService-gradientBg">
//                 <h2 className="GasChulaService-sectionTitle">
//                   {t("gasChula.additional_info.key_features.title")}
//                 </h2>
//                 <div className="GasChulaService-featureGrid">
//                   {getTranslationArray(
//                     "gasChula.additional_info.key_features.features"
//                   ).map((feature, idx) => (
//                     <div key={idx} className="GasChulaService-featureItem">
//                       <i
//                         className={`fas fa-${
//                           idx === 0
//                             ? "clock"
//                             : idx === 1
//                             ? "shield-alt"
//                             : idx === 2
//                             ? "check-circle"
//                             : idx === 3
//                             ? "shield-alt"
//                             : "credit-card"
//                         } GasChulaService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             <div className="GasChulaService-sectionCard">
//               <h2 className="GasChulaService-sectionTitle">
//                 {t("gasChula.additional_info.service_details.title")}
//               </h2>
//               <div className="GasChulaService-serviceGrid">
//                 {getTranslationArray(
//                   "gasChula.additional_info.service_details.items"
//                 ).map((item, idx) => (
//                   <div key={idx} className="GasChulaService-serviceItem">
//                     <i
//                       className={`fas fa-${
//                         idx === 0 ? "fire" : "tools"
//                       } GasChulaService-serviceIcon`}
//                       aria-hidden="true"
//                     ></i>
//                     <div>
//                       <h3>{item.title}</h3>
//                       <p>{item.description}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div className="GasChulaService-sectionCard GasChulaService-gradientBg3">
//               <h2 className="GasChulaService-sectionTitle">
//                 {t("gasChula.additional_info.order_tracking.title")}
//               </h2>
//               <div className="GasChulaService-orderTrackIcon">
//                 <i className="fas fa-file-alt" aria-hidden="true"></i>
//               </div>
//               <p className="GasChulaService-sectionText GasChulaService-centerText">
//                 {t("gasChula.additional_info.order_tracking.description")}
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Modals */}
//         {showOrderForm && (
//           <GasChulaOrderForm
//             onClose={() => setShowOrderForm(false)}
//             onSubmit={handleOrderSubmit}
//             formData={formData}
//             user={user}
//             previousServitorName={prevServitorName}
//           />
//         )}
//         {showLoginPrompt && (
//           <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
//         )}
//       </div>

//       {/* Feedback Section */}
//       {ratingData.reviewCount > 0 && (
//       <div className="GasChulaService-feedback-section">
//         <FeedbackPage serviceType="Gas Chula" />
//       </div>
//       )}

//       <Footer />
//     </>
//   );
// };

// export default GasChula;






// ***** Uppdated and add servicePrice.js pricebreakdown (25-Oct-2025) *****
import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../../../Components/Navbar";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { URL } from "../../../config";
import { useTranslation } from "react-i18next";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  FaCalendarAlt,
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
} from "react-icons/fa";

import PromptLoginCard from "../PromptLoginCard";
import FeedbackPage from "../../Feedback/FeedbackPage";
import Footer from "../../../Components/Footer/Footer";
import GasChulaOrderForm from "./GasChulaOrderForm";

import heroImage from "../images/Gaschula-service-banner.png";
import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";

import "./gasChulaStyle.css";
import Loader from "../../../Components/LoaderSpin/Loader";
import { GAS_CHULA_PRICING } from "../servicePricing";
import SEO from "../../../Components/SEO/SEO";

const P = GAS_CHULA_PRICING;
// const BASE_FEE = Number(P?.base ?? 0);
const CHECK_ISSUES_FEE = Number(P?.checkIssuesFlat ?? 0);
const PLATFORM_PERCENT = Number(P?.platformFee?.percent ?? 0.05);
const PLATFORM_MIN = Number(P?.platformFee?.min ?? 50);

const GasChula = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const rebookState = location.state?.fromRebook || false;
  const prevOrder = useMemo(
    () => location.state?.previousOrder || {},
    [location.state?.previousOrder]
  );

  // Form fields
  const [cylinderType, setCylinderType] = useState("");
  const [newChulaSetup, setNewChulaSetup] = useState(0);
  const [chulaSetup, setChulaSetup] = useState(0);
  const [burnerSetup, setBurnerSetup] = useState(0);
  const [burnerCleaning, setBurnerCleaning] = useState(0);
  const [nozzleReplacement, setNozzleReplacement] = useState(0);
  const [checkIssues, setCheckIssues] = useState(false);
  const [remarks, setRemarks] = useState("");

  // Rebook same servitor
  const [useSameServitor, setUseSameServitor] = useState(false);
  const [prevServitorName, setPrevServitorName] = useState("");

  // Rating data
  const [ratingData, setRatingData] = useState({
    reviewCount: 0,
    avgRating: 0,
  });

  const [showOrderForm, setShowOrderForm] = useState(false);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);


  const toLocalYMD = (d) => {
    const x = new Date(d);
    const y = x.getFullYear();
    const m = String(x.getMonth() + 1).padStart(2, "0");
    const day = String(x.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };
  // Date & time
  // const getInitialDate = () => {
  //   const now = new Date();
  //   const currentHour = now.getHours();
  //   if (currentHour < 7 || currentHour >= 21) {
  //     const tomorrow = new Date();
  //     tomorrow.setDate(now.getDate() + 1);
  //     return tomorrow;
  //   }
  //   return now;
  // };

  const getInitialDate = () => {
    const now = new Date();
    const currentHour = now.getHours();

    // before 7am or after/equal 9pm -> tomorrow
    if (currentHour < 7 || currentHour >= 21) {
      const tomorrow = new Date(now);
      tomorrow.setDate(now.getDate() + 1);
      return tomorrow;
    }
    return now;
  };


  const [selectedDate, setSelectedDate] = useState(getInitialDate());

  // Populate fields for rebook
  useEffect(() => {
    if (rebookState) {
      setCylinderType(prevOrder.chulaCylinderType || "");
      setNewChulaSetup(prevOrder.NewchulaSetup || 0);
      setChulaSetup(prevOrder.chulaSetup || 0);
      setBurnerSetup(prevOrder.burnerSetup || 0);
      setBurnerCleaning(prevOrder.burnerCleaning || 0);
      setNozzleReplacement(prevOrder.nozzleReplacement || 0);
      setCheckIssues(prevOrder.checkIssues || false);
      setRemarks(prevOrder.remarks || "");
    }
  }, [rebookState, prevOrder]);

  // Fetch user profile
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        if (token) {
          const decodedToken = jwtDecode(token);
          const userId = decodedToken.Id.startsWith("user-")
            ? decodedToken.Id.split("user-")[1]
            : decodedToken.Id;

          const response = await axios.get(`${URL}/user/${userId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setUser(response.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
    window.scrollTo(0, 0);
  }, []);

  // Fetch servitor name for rebook
  useEffect(() => {
    if (rebookState && prevOrder.servitor_id) {
      axios
        .get(`${URL}/servitors/${prevOrder.servitor_id}`)
        .then((res) => {
          const s = res.data;
          setPrevServitorName(`${s.FirstName} ${s.LastName}`);
        })
        .catch((err) => console.error("Error fetching servitor:", err));
    }
  }, [rebookState, prevOrder.servitor_id]);

  // Fetch gas chula ratings
  // useEffect(() => {
  //   axios
  //     .get(`${URL}/api/ratings`)
  //     .then(({ data }) => {
  //       // const { gasChula } = data;
  //       // const gasChula = data?.gasChula || {};
  //       const gasChula = data["gas chula"] || {};
  //       setRatingData({
  //         reviewCount: gasChula.reviewCount || 0,
  //         avgRating: gasChula.avgRating || 0,
  //       });
  //     })
  //     .catch((err) => {console.error("Failed to load ratings:", err)});
  // }, []);

  useEffect(() => {
    const loadRatings = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(`${URL}/api/ratings`);
        // handle different backend key styles
        const gasChula = data["gas chula"] || {};
        setRatingData({
          reviewCount: gasChula.reviewCount || 0,
          avgRating: gasChula.avgRating || 0,
        });
      } catch (err) {
        console.error("Failed to load ratings:", err);
      } finally {
        setLoading(false);
      }
    };
    loadRatings();
  }, []);

  // Render star ratings
  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(<FaStar key={i} />);
      } else if (rating >= i - 0.5) {
        stars.push(<FaStarHalfAlt key={i} />);
      } else {
        stars.push(<FaRegStar key={i} />);
      }
    }
    return stars;
  };

  // Generate time slots
  const generateTimeSlots = (dateObj) => {
    const startTime = 7;
    const endTime = 21;
    const slots = [];
    const now = new Date();
    // const todayStr = now.toISOString().split("T")[0];
    // const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";

    const todayStr = toLocalYMD(now);
    const selectedDateStr = dateObj ? toLocalYMD(dateObj) : "";

    let startHour = startTime;
    let startMinute = 0;

    if (selectedDateStr === todayStr) {
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      if (currentHour >= endTime) {
        return [];
      }
      if (currentHour >= startTime) {
        if (currentMinute > 0 && currentMinute <= 30) {
          startHour = currentHour;
          startMinute = 30;
        } else if (currentMinute > 30) {
          startHour = currentHour + 1;
          startMinute = 0;
        } else {
          startHour = currentHour;
          startMinute = 0;
        }
      }
    }

    for (let hour = startHour; hour <= endTime; hour++) {
      const minuteStart = hour === startHour ? startMinute : 0;
      for (let minute = minuteStart; minute < 60; minute += 30) {
        if (selectedDateStr === todayStr) {
          const slotTime = new Date(now);
          slotTime.setHours(hour, minute, 0, 0);
          if (slotTime <= now) continue;
        }
        const displayHour = hour > 12 ? hour - 12 : hour;
        const ampm = hour >= 12 ? "PM" : "AM";
        const formattedTime = `${displayHour}:${String(minute).padStart(
          2,
          "0"
        )} ${ampm}`;
        slots.push(formattedTime);
      }
    }
    return slots;
  };

  // Calculate price
  // const calculatePrice = () => {
  //   let price = 100;
  //   price += newChulaSetup * 500;
  //   price += chulaSetup * 300;
  //   price += burnerSetup * 200;
  //   price += burnerCleaning * 150;
  //   price += nozzleReplacement * 120;
  //   if (checkIssues) price += 100;
  //   return price;
  // };

  // ============ Pricing helpers ============
  const U = (v) => Math.max(0, Number(v) || 0);
  const fmtTk = (n) => `${(Number(n) || 0).toLocaleString()} tk`;
  const unit = (key) => Number(P?.perUnit?.[key] ?? 0);

  // show totals only after something is chosen
  const hasAnySelection = useMemo(() => {
    const counts = [
      newChulaSetup,
      chulaSetup,
      burnerSetup,
      burnerCleaning,
      nozzleReplacement,
    ];
    return counts.some((c) => U(c) > 0) || !!checkIssues;
  }, [
    newChulaSetup,
    chulaSetup,
    burnerSetup,
    burnerCleaning,
    nozzleReplacement,
    checkIssues,
  ]);

  // Total price
  // const calculatePrice = () => {
  //   let price = 0;

  //   if (hasAnySelection) {
  //     price += BASE_FEE;
  //   }

  //   price += U(newChulaSetup) * unit("newChulaSetup");
  //   price += U(chulaSetup) * unit("chulaSetup");
  //   price += U(burnerSetup) * unit("burnerSetup");
  //   price += U(burnerCleaning) * unit("burnerCleaning");
  //   price += U(nozzleReplacement) * unit("nozzleReplacement");

  //   if (checkIssues) {
  //     price += CHECK_ISSUES_FEE;
  //   }

  //   return Math.round(price);
  // };

  const calculatePrice = () => {
  let subtotal = 0;

  subtotal += U(newChulaSetup) * unit("newChulaSetup");
  subtotal += U(chulaSetup) * unit("chulaSetup");
  subtotal += U(burnerSetup) * unit("burnerSetup");
  subtotal += U(burnerCleaning) * unit("burnerCleaning");
  subtotal += U(nozzleReplacement) * unit("nozzleReplacement");

  if (checkIssues) subtotal += CHECK_ISSUES_FEE;

  subtotal = Math.round(subtotal);

  if (subtotal <= 0) return 0;

  const platformFee = Math.max(PLATFORM_MIN, Math.round(subtotal * PLATFORM_PERCENT));
  return Math.round(subtotal + platformFee);
};

  // Breakdown rows
  const breakdownRows = useMemo(() => {
    const rows = [];
    const add = (label, count, key) => {
      const c = U(count);
      if (!c) return;
      const each = unit(key);
      rows.push({
        label,
        calc: `${c} × ${fmtTk(each)} =`,
        total: fmtTk(c * each),
      });
    };

    add(
      t("gasChula.breakdown.new_chula_setup", "New Chula Setup"),
      newChulaSetup,
      "newChulaSetup"
    );
    add(
      t("gasChula.breakdown.chula_setup", "Chula Setup"),
      chulaSetup,
      "chulaSetup"
    );
    add(
      t("gasChula.breakdown.burner_setup", "Burner Setup"),
      burnerSetup,
      "burnerSetup"
    );
    add(
      t("gasChula.breakdown.burner_cleaning", "Burner Cleaning"),
      burnerCleaning,
      "burnerCleaning"
    );
    add(
      t("gasChula.breakdown.nozzle_replacement", "Nozzle Replacement"),
      nozzleReplacement,
      "nozzleReplacement"
    );

    if (checkIssues) {
      rows.push({
        label: t("gasChula.breakdown.check_issues", "Check Issues"),
        calc: "",
        total: fmtTk(CHECK_ISSUES_FEE),
      });
    }

    // if (rows.length > 0 && BASE_FEE > 0) {
    //   rows.push({
    //     // label: t("gasChula.breakdown.booking_fee", "Booking Fee"),
    //     label: t("gasChula.breakdown.platform_support_fee", "Platform & Support Fee"),
    //     calc: "",
    //     total: fmtTk(BASE_FEE),
    //   });
    // }

    const subtotal =
      U(newChulaSetup) * unit("newChulaSetup") +
      U(chulaSetup) * unit("chulaSetup") +
      U(burnerSetup) * unit("burnerSetup") +
      U(burnerCleaning) * unit("burnerCleaning") +
      U(nozzleReplacement) * unit("nozzleReplacement") +
      (checkIssues ? CHECK_ISSUES_FEE : 0);

    if (subtotal > 0) {
      const platformFee = Math.max(PLATFORM_MIN, Math.round(subtotal * PLATFORM_PERCENT));
      rows.push({
        label: t("gasChula.breakdown.platform_support_fee", "Platform & Support Fee"),
        // calc: "",
        total: fmtTk(platformFee),
      });
    }

    return rows;
  }, [
    t,
    newChulaSetup,
    chulaSetup,
    burnerSetup,
    burnerCleaning,
    nozzleReplacement,
    checkIssues,
  ]);


  // Handle form submission
  const handleGetService = (e) => {
    e.preventDefault();

    if (!hasAnySelection) return;

    // const dateStr = selectedDate.toISOString().split("T")[0];
    const dateStr = selectedDate ? toLocalYMD(selectedDate) : "";

    const time = e.target.time.value;

    const formDetails = {
      chulaCylinderType: cylinderType,
      NewchulaSetup: newChulaSetup,
      chulaSetup,
      burnerSetup,
      burnerCleaning,
      nozzleReplacement,
      checkIssues,
      remarks,
      price: calculatePrice(),
      date: dateStr,
      time,
      useSameServitor,
      previousServitorId: useSameServitor ? prevOrder.servitor_id : undefined,
      serviceId: 4, // Assuming Gas Chula service ID is 4
    };
    setFormData(formDetails);

    if (user) {
      setShowOrderForm(true);
    } else {
      setShowLoginPrompt(true);
    }
  };

  // Handle order submission
  const handleOrderSubmit = () => {
    setShowOrderForm(false);
    // Reset form
    setCylinderType("");
    setNewChulaSetup(0);
    setChulaSetup(0);
    setBurnerSetup(0);
    setBurnerCleaning(0);
    setNozzleReplacement(0);
    setCheckIssues(false);
    setRemarks("");
    setUseSameServitor(false);
    setFormData({});
  };

  // PlusMinusInput component
  const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
    const handleIncrement = () => {
      if (value < max) setValue(value + 1);
    };
    const handleDecrement = () => {
      if (value > min) setValue(value - 1);
    };
    return (
      <div className="GasChulaService-plusMinusInput" id={id}>
        <button
          type="button"
          className="GasChulaService-minusBtn"
          onClick={handleDecrement}
          disabled={value <= min}
          aria-label={t("common.decrease", "Decrease")}
        >
          −
        </button>
        <span className="GasChulaService-valueDisplay">
          {value} {t(value === 1 ? "gasChula.form.unit" : "gasChula.form.units")}
        </span>
        <button
          type="button"
          className="GasChulaService-plusBtn"
          onClick={handleIncrement}
          disabled={value >= max}
          aria-label={t("common.increase", "Increase")}
        >
          +
        </button>
      </div>
    );
  };

  // Helper to safely get array translations
  const getTranslationArray = (key) => {
    const result = t(key, { returnObjects: true });
    return Array.isArray(result) ? result : [];
  };

  return (
    <>
      <div className="GasChulaService-container">

        <SEO
          title="Gas Chula Service in Dhaka | Repair, Installation & Checkup | HelpNao"
          description="Get expert gas chula service for burner repair, chula installation, nozzle setup, gas leakage checkup, flame issue fixing, and safety inspection. Trusted professionals."
          path="/services/gas-chula"
          lang="en"
          jsonLd={{
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Gas Chula Service",
            "serviceType": "Gas Stove Service",
            "provider": { "@type": "Organization", "name": "HelpNao", "url": "https://helpnao.com" },
            "areaServed": { "@type": "City", "name": "Dhaka" },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Gas Stove Services",
              "itemListElement": [
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Gas Chula Installation / Setup" } },
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Burner Repair / Replacement" } },
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Nozzle Setup / Cleaning" } },
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Flame Low / Flame Problem Fix" } },
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Gas Leakage Checkup & Safety Inspection" } }
              ]
            }
          }}
        />


        <Navbar />
        <Loader show={loading} />

        {/* Service Card */}
        <div className="GasChulaService-card">
          {/* Hero Section */}
          <div className="GasChulaService-hero">
            <img src={heroImage} alt={t("gasChula.hero_alt")} />
          </div>

          <div className="GasChulaService-header">
            <h1>
              {rebookState
                ? t("gasChula.header.rebook_title")
                : t("gasChula.header.title")}
            </h1>
            <div className="GasChulaService-rating">
              {renderStars(ratingData.avgRating)}
            </div>
            <div className="GasChulaService-reviews">
              {ratingData.reviewCount.toLocaleString()}{" "}
              {t("gasChula.reviewsLabel")}
            </div>
          </div>

          {/* Categories / Info Blocks */}
          {/* <div className="GasChulaService-categories">
            <div className="GasChulaService-category">
              <h5>
                <span className="GasChulaService-categoryIcon">🔥</span>
                {t("gasChula.categories.setup_services.title")}
              </h5>
              <p className="GasChulaService-serviceDescription">
                {t("gasChula.categories.setup_services.description")}
              </p>
            </div>
            <div className="GasChulaService-category">
              <h5>
                <span className="GasChulaService-categoryIcon">🛠️</span>
                {t("gasChula.categories.maintenance.title")}
              </h5>
              <p className="GasChulaService-serviceDescription">
                {t("gasChula.categories.maintenance.description")}
              </p>
            </div>
            <div className="GasChulaService-category">
              <h5>
                <span className="GasChulaService-categoryIcon">🔍</span>
                {t("gasChula.categories.safety_check.title")}
              </h5>
              <p className="GasChulaService-serviceDescription">
                {t("gasChula.categories.safety_check.description")}
              </p>
            </div>
          </div> */}

          {/* The Service Form */}
          <form onSubmit={handleGetService} className="GasChulaService-form">
            {/* Cylinder Type */}
            <h3 className="GasChulaService-sectionTitle">
              <i className="fas fa-gas-pump"></i>
              {t("gasChula.form.cylinder_type_title")}
            </h3>
            <div className="GasChulaService-serviceOptions">
              <div className="GasChulaService-optionGroup GasChulaService-fullWidth">
                <label htmlFor="cylinderType">
                  {t("gasChula.form.labels.cylinderType")}
                </label>
                <select
                  id="cylinderType"
                  value={cylinderType}
                  onChange={(e) => setCylinderType(e.target.value)}
                  required
                >
                  <option value="">
                    {t("gasChula.form.placeholders.select")}
                  </option>
                  <option value="LPG">LPG</option>
                  <option value="Line Gas">Line Gas</option>
                </select>
              </div>
            </div>

            {/* Setup Services */}
            <h3 className="GasChulaService-sectionTitle">
              <i className="fas fa-tools"></i>
              {t("gasChula.form.setup_services_title")}
            </h3>
            <div className="GasChulaService-serviceOptions">
              <div className="GasChulaService-optionGroup">
                <label htmlFor="newChulaSetup" className="tooltip-label">
                  {t("gasChula.form.labels.newSetup")}
                  <ServiceTooltip
                    title={t("gasChula.tooltips.newSetup.title")}
                    //  description={t("gasChula.tooltips.newSetup.description")}
                    description={t("gasChula.tooltips.newSetup.description", {
                      price: unit("newChulaSetup"),
                    })}
                  />
                </label>
                <PlusMinusInput
                  id="newChulaSetup"
                  value={newChulaSetup}
                  setValue={setNewChulaSetup}
                />
              </div>
              <div className="GasChulaService-optionGroup">
                <label htmlFor="chulaSetup" className="tooltip-label">
                  {t("gasChula.form.labels.chulaSetup")}
                  <ServiceTooltip
                    title={t("gasChula.tooltips.chulaSetup.title")}
                    // description={t("gasChula.tooltips.chulaSetup.description")}
                    description={t("gasChula.tooltips.chulaSetup.description", {
                      price: unit("chulaSetup"),
                    })}
                  />
                </label>
                <PlusMinusInput
                  id="chulaSetup"
                  value={chulaSetup}
                  setValue={setChulaSetup}
                />
              </div>
              <div className="GasChulaService-optionGroup">
                <label htmlFor="burnerSetup" className="tooltip-label">
                  {t("gasChula.form.labels.burnerSetup")}
                  <ServiceTooltip
                    title={t("gasChula.tooltips.burnerSetup.title")}
                    // description={t("gasChula.tooltips.burnerSetup.description")}
                    description={t("gasChula.tooltips.burnerSetup.description", {
                      price: unit("burnerSetup"),
                    })}
                  />
                </label>
                <PlusMinusInput
                  id="burnerSetup"
                  value={burnerSetup}
                  setValue={setBurnerSetup}
                />
              </div>
            </div>

            {/* Maintenance Services */}
            <h3 className="GasChulaService-sectionTitle">
              <i className="fas fa-wrench"></i>
              {t("gasChula.form.maintenance_services_title")}
            </h3>
            <div className="GasChulaService-serviceOptions">
              <div className="GasChulaService-optionGroup">
                <label htmlFor="burnerCleaning" className="tooltip-label">
                  {t("gasChula.form.labels.burnerCleaning")}
                  <ServiceTooltip
                    title={t("gasChula.tooltips.burnerCleaning.title")}
                    // description={t("gasChula.tooltips.burnerCleaning.description")}
                    description={t("gasChula.tooltips.burnerCleaning.description", {
                      price: unit("burnerCleaning"),
                    })}
                  />
                </label>
                <PlusMinusInput
                  id="burnerCleaning"
                  value={burnerCleaning}
                  setValue={setBurnerCleaning}
                />
              </div>
              <div className="GasChulaService-optionGroup">
                <label htmlFor="nozzleReplacement" className="tooltip-label">
                  {t("gasChula.form.labels.nozzleReplacement")}
                  <ServiceTooltip
                    title={t("gasChula.tooltips.nozzleReplacement.title")}
                    // description={t("gasChula.tooltips.nozzleReplacement.description")}
                    description={t("gasChula.tooltips.nozzleReplacement.description", {
                      price: unit("nozzleReplacement"),
                    })}
                  />
                </label>
                <PlusMinusInput
                  id="nozzleReplacement"
                  value={nozzleReplacement}
                  setValue={setNozzleReplacement}
                />
              </div>
              <div className="GasChulaService-optionGroup">
                <label htmlFor="checkIssues" className="tooltip-label">
                  {t("gasChula.form.labels.checkIssues")}
                  <ServiceTooltip
                    title={t("gasChula.tooltips.checkIssues.title")}
                    // description={t("gasChula.tooltips.checkIssues.description")}
                    description={t("gasChula.tooltips.checkIssues.description", {
                      price: CHECK_ISSUES_FEE,
                    })}
                  />
                </label>
                <select
                  id="checkIssues"
                  value={checkIssues ? "yes" : "no"}
                  onChange={(e) => setCheckIssues(e.target.value === "yes")}
                >
                  <option value="no">
                    {t("gasChula.form.labels.checkIssues_options.no")}
                  </option>
                  <option value="yes">
                    {t("gasChula.form.labels.checkIssues_options.yes")}
                  </option>
                </select>
              </div>
            </div>

            {/* Rebook Same Servitor */}
            {rebookState && prevServitorName && (
              <div className="GasChulaService-rebook-same-servitor">
                <label>
                  <input
                    type="checkbox"
                    checked={useSameServitor}
                    onChange={() => setUseSameServitor(!useSameServitor)}
                  />
                  <span className="rebook-text">
                    {t("gasChula.form.rebook_same_servitor_prefix")}
                    <span className="strong-name">{prevServitorName}</span>
                    {t("gasChula.form.rebook_same_servitor_suffix")}
                  </span>
                </label>
              </div>
            )}


            {/* ---------- Price Breakdown Card (only when selected) ---------- */}
            {breakdownRows.length > 0 && (
              <div className="GasChulaService-breakdownCard" aria-live="polite">
                <div className="GasChulaService-breakdownHeader">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 4v4h10V6H7zm0 6v6h10v-6H7zm2 1h2v2H9v-2zm0 3h2v2H9v-2zm4-3h2v2h-2v-2zm0 3h2v2h-2v-2z" />
                  </svg>
                  <span>{t("gasChula.breakdown.title", "Price Breakdown")}</span>
                </div>
                <ul className="GasChulaService-breakdownList">
                  {breakdownRows.map((row, idx) => (
                    <li key={idx} className="GasChulaService-breakdownRow">
                      <span className="GasChulaService-breakdownLabel">
                        {row.label}
                      </span>
                      <span className="GasChulaService-breakdownRight">
                        {row.calc && (
                          <span className="GasChulaService-breakdownCalc">
                            {row.calc}
                          </span>
                        )}
                        <span className="GasChulaService-breakdownTotal">
                          {row.total}
                        </span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Price Display */}
            <div className="GasChulaService-priceDisplay">
              <span>
                {t("gasChula.form.price_display", { price: calculatePrice() })}
              </span>
              {/* <small>{t("gasChula.form.price_note")}</small> */}
            </div>

            {/* Pricing note banner */}
            <div className="GasChulaService-priceNote" role="note" aria-live="polite">
              <div className="GasChulaService-priceNote-icon" aria-hidden="true">
                {/* small star icon (inline SVG) */}
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                </svg>
              </div>
              <div className="GasChulaService-priceNote-content">
                <div className="GasChulaService-priceNote-title">
                  {t("gasChula.price_note.title")}
                </div>
                <p className="GasChulaService-priceNote-text">
                  <strong>{t("gasChula.price_note.service_charges_only_label")}</strong>{" "}
                  {t("gasChula.price_note.body")}
                </p>
              </div>
            </div>



            {/* Booking Details */}
            <div className="GasChulaService-bookingDetails">
              <div className="GasChulaService-optionGroup">
                <label htmlFor="date">{t("gasChula.form.labels.date")}</label>
                <div className="GasChulaService-dateInputWrapper">
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    dateFormat="dd-MMM-yyyy"
                    minDate={new Date()}
                    placeholderText={t("gasChula.form.labels.date")}
                    className="GasChulaService-dateInput"
                  />
                  <FaCalendarAlt
                    className="GasChulaService-dateIcon"
                    onClick={() =>
                      document
                        .querySelector(".GasChulaService-dateInput")
                        .focus()
                    }
                  />
                </div>
              </div>
              <div className="GasChulaService-optionGroup">
                <label htmlFor="time">{t("gasChula.form.labels.time")}</label>
                <select id="time" name="time" required>
                  {generateTimeSlots(selectedDate).map((slot, idx) => (
                    <option key={idx} value={slot}>
                      {slot}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Remarks */}
            <div className="GasChulaService-serviceOptions">
              <div className="GasChulaService-optionGroup GasChulaService-fullWidth">
                <label htmlFor="remarks">
                  <i className="fas fa-comment-alt"></i>
                  {t("gasChula.form.labels.remarks")}
                </label>
                <textarea
                  id="remarks"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder={t("gasChula.form.placeholders.remarks")}
                  className="GasChulaService-textarea"
                  rows="2"
                />
              </div>
            </div>

            <button type="submit"
              className="GasChulaService-actionBtn"
              disabled={!hasAnySelection}
              aria-disabled={!hasAnySelection}
            >
              {rebookState
                ? t("gasChula.form.rebook_button")
                : t("gasChula.form.book_button")}
            </button>
          </form>

          {/* Info Box */}
          <div className="GasChulaService-infoBox">
            <h4>{t("gasChula.info_box.title")}</h4>
            <p>{t("gasChula.info_box.description")}</p>
          </div>

          {/* Additional Info Section */}
          <div className="GasChulaService-additionalInfo">
            <div className="GasChulaService-sectionCard">
              <h2 className="GasChulaService-sectionTitle">
                {t("gasChula.additional_info.how_to_place_order.title")}
              </h2>
              <ol className="GasChulaService-stepList">
                {getTranslationArray(
                  "gasChula.additional_info.how_to_place_order.steps"
                ).map((step, idx) => (
                  <li key={idx}>{step}</li>
                ))}
              </ol>
            </div>

            <div className="GasChulaService-row2col">
              <div className="GasChulaService-sectionCard GasChulaService-gradientBg2">
                <h2 className="GasChulaService-sectionTitle">
                  {t("gasChula.additional_info.why_choose_HelpNao.title")}
                </h2>
                <p className="GasChulaService-sectionText">
                  {t("gasChula.additional_info.why_choose_HelpNao.description")}
                </p>
                <div className="GasChulaService-featureGrid">
                  {getTranslationArray(
                    "gasChula.additional_info.why_choose_HelpNao.features"
                  ).map((feature, idx) => (
                    <div key={idx} className="GasChulaService-featureItem">
                      <i
                        className={`fas fa-${idx === 0
                            ? "balance-scale"
                            : idx === 1
                              ? "user-shield"
                              : idx === 2
                                ? "mobile-alt"
                                : "headset"
                          } GasChulaService-featureIcon`}
                        aria-hidden="true"
                      ></i>
                      <p>{feature}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="GasChulaService-sectionCard GasChulaService-gradientBg">
                <h2 className="GasChulaService-sectionTitle">
                  {t("gasChula.additional_info.key_features.title")}
                </h2>
                <div className="GasChulaService-featureGrid">
                  {getTranslationArray(
                    "gasChula.additional_info.key_features.features"
                  ).map((feature, idx) => (
                    <div key={idx} className="GasChulaService-featureItem">
                      <i
                        className={`fas fa-${idx === 0
                            ? "clock"
                            : idx === 1
                              ? "shield-alt"
                              : idx === 2
                                ? "check-circle"
                                : idx === 3
                                  ? "shield-alt"
                                  : "credit-card"
                          } GasChulaService-featureIcon`}
                        aria-hidden="true"
                      ></i>
                      <p>{feature}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="GasChulaService-sectionCard">
              <h2 className="GasChulaService-sectionTitle">
                {t("gasChula.additional_info.service_details.title")}
              </h2>
              <div className="GasChulaService-serviceGrid">
                {getTranslationArray(
                  "gasChula.additional_info.service_details.items"
                ).map((item, idx) => (
                  <div key={idx} className="GasChulaService-serviceItem">
                    <i
                      className={`fas fa-${idx === 0 ? "fire" : "tools"
                        } GasChulaService-serviceIcon`}
                      aria-hidden="true"
                    ></i>
                    <div>
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="GasChulaService-sectionCard GasChulaService-gradientBg3">
              <h2 className="GasChulaService-sectionTitle">
                {t("gasChula.additional_info.order_tracking.title")}
              </h2>
              <div className="GasChulaService-orderTrackIcon">
                <i className="fas fa-file-alt" aria-hidden="true"></i>
              </div>
              <p className="GasChulaService-sectionText GasChulaService-centerText">
                {t("gasChula.additional_info.order_tracking.description")}
              </p>
            </div>
          </div>
        </div>

        {/* Modals */}
        {showOrderForm && (
          <GasChulaOrderForm
            onClose={() => setShowOrderForm(false)}
            onSubmit={handleOrderSubmit}
            formData={formData}
            user={user}
            previousServitorName={prevServitorName}
          />
        )}
        {showLoginPrompt && (
          <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
        )}
      </div>

      {/* Feedback Section */}
      {ratingData.reviewCount > 0 && (
        <div className="GasChulaService-feedback-section">
          <FeedbackPage serviceType="Gas Chula" />
        </div>
      )}

      <Footer />
    </>
  );
};

export default GasChula;